import { JobLogActions } from "../actions";

const initialState = {
  rows: [],
  rowCount: 1,
  pageCount: 1,
  jobMonitoring: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function jobLog(state = initialState, action) {
  switch (action.type) {
    case JobLogActions.ACTION_SAVE_JOBLOGS:
      return {
        ...state,
        rows: action.payload.rows,
        rowCount: action.payload.rowCount,
        pageCount: action.payload.pageCount,
      };
    case JobLogActions.ACTION_SAVE_JOB_MONITORING:
      return {
        ...state,
        jobMonitoring: action.payload,
      };
    default:
      return state;
  }
}

export function getJobLogs(state) {
  return {
    rows: state.jobLog.rows,
    rowCount: state.jobLog.rowCount,
    pageCount: state.jobLog.pageCount,
  };
}

export function getJobMonitoring(state) {
  return state.jobLog.jobMonitoring;
}
